(function() {
            var bar = document.getElementById('Mepilo-sticky-bar');
            if (bar) {
                window.addEventListener('scroll', function() {
                    if (window.scrollY > 50) {
                        bar.style.boxShadow = '0 4px 24px rgba(0,0,0,0.1), 0 1px 6px rgba(0,0,0,0.06)';
                        bar.style.background = 'rgba(255,255,255,0.94)';
                        bar.classList.add('Mepilo-scrolled');
                    } else {
                        bar.style.boxShadow = 'none';
                        bar.style.background = 'rgba(255,255,255,0.88)';
                        bar.classList.remove('Mepilo-scrolled');
                    }
                });
            }
        })();

(function() {
  const slimToggleCard = function(header) {
    const card = header.parentElement;
    const body = card.querySelector('.slim-card-body');
    const isOpen = card.classList.contains('is-open');
    const allCards = card.parentElement.querySelectorAll('.slim-card');

    allCards.forEach(c => {
      if (c !== card && c.classList.contains('is-open')) {
        const otherBody = c.querySelector('.slim-card-body');
        c.classList.remove('is-open');
        c.querySelector('.slim-card-header').setAttribute('aria-expanded', 'false');
        if (otherBody) otherBody.style.maxHeight = '0px';
      }
    });

    if (isOpen) {
      card.classList.remove('is-open');
      header.setAttribute('aria-expanded', 'false');
      body.style.maxHeight = '0px';
    } else {
      card.classList.add('is-open');
      header.setAttribute('aria-expanded', 'true');
      body.style.maxHeight = body.scrollHeight + 'px';
    }
  };

  document.querySelectorAll('.slim-card-header').forEach(header => {
    header.addEventListener('click', function(e) {
      slimToggleCard(this);
    });
    header.addEventListener('keydown', function(e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        slimToggleCard(this);
      }
    });
  });

  const scrollContainer = document.getElementById('slimCardsHorizontal');
  const dots = document.querySelectorAll('.slim-scroll-dot');
  const mobileCards = document.querySelectorAll('.slim-card-h');
  let scrollVelocity = 0, lastScrollLeft = 0, lastTime = Date.now(), animationFrameId = null;

  function updateActiveCard() {
    if (!scrollContainer) return;
    const scrollLeft = scrollContainer.scrollLeft;
    const containerWidth = scrollContainer.clientWidth;
    const center = scrollLeft + containerWidth / 2;
    let activeIndex = 0, minDistance = Infinity;
    mobileCards.forEach((card, i) => {
      const cardCenter = card.offsetLeft + card.offsetWidth / 2;
      const distance = Math.abs(center - cardCenter);
      if (distance < minDistance) { minDistance = distance; activeIndex = i; }
    });
    mobileCards.forEach((card, i) => card.classList.toggle('is-active', i === activeIndex));
    dots.forEach((dot, i) => dot.classList.toggle('is-active', i === activeIndex));
  }

  function applyInertiaScroll() {
    if (Math.abs(scrollVelocity) < 0.4) {
      snapToNearestCard();
      animationFrameId = null;
      return;
    }
    scrollContainer.scrollLeft += scrollVelocity;
    scrollVelocity *= 0.91;
    updateActiveCard();
    animationFrameId = requestAnimationFrame(applyInertiaScroll);
  }

  function snapToNearestCard() {
    const center = scrollContainer.scrollLeft + scrollContainer.clientWidth / 2;
    let bestCard = null, minDist = Infinity;
    mobileCards.forEach(card => {
      const cardCenter = card.offsetLeft + card.offsetWidth / 2;
      const dist = Math.abs(center - cardCenter);
      if (dist < minDist) { minDist = dist; bestCard = card; }
    });
    if (bestCard) {
      const targetScroll = bestCard.offsetLeft + bestCard.offsetWidth / 2 - scrollContainer.clientWidth / 2;
      scrollContainer.scrollTo({ left: Math.max(0, targetScroll), behavior: 'smooth' });
    }
  }

  if (scrollContainer) {
    scrollContainer.addEventListener('scroll', () => {
      const now = Date.now(), dt = now - lastTime;
      if (dt > 0) scrollVelocity = (scrollContainer.scrollLeft - lastScrollLeft) / dt * 16;
      lastScrollLeft = scrollContainer.scrollLeft;
      lastTime = now;
      updateActiveCard();
      clearTimeout(scrollContainer._timeout);
      scrollContainer._timeout = setTimeout(() => {
        if (Math.abs(scrollVelocity) > 0.4) animationFrameId = requestAnimationFrame(applyInertiaScroll);
        else snapToNearestCard();
      }, 70);
    });
    scrollContainer.addEventListener('touchstart', () => {
      if (animationFrameId) cancelAnimationFrame(animationFrameId);
      scrollVelocity = 0;
    }, { passive: true });
    scrollContainer.addEventListener('touchend', () => {
      lastTime = Date.now(); lastScrollLeft = scrollContainer.scrollLeft;
      setTimeout(() => {
        if (Math.abs(scrollVelocity) > 0.4) animationFrameId = requestAnimationFrame(applyInertiaScroll);
        else snapToNearestCard();
      }, 25);
    }, { passive: true });
    updateActiveCard();
  }

  dots.forEach(dot => {
    dot.addEventListener('click', () => {
      const index = parseInt(dot.getAttribute('data-dot'));
      const card = mobileCards[index];
      if (card && scrollContainer) {
        const targetScroll = card.offsetLeft + card.offsetWidth / 2 - scrollContainer.clientWidth / 2;
        scrollContainer.scrollTo({ left: Math.max(0, targetScroll), behavior: 'smooth' });
        if (animationFrameId) cancelAnimationFrame(animationFrameId);
        scrollVelocity = 0;
      }
    });
  });

  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => { if (entry.isIntersecting) entry.target.classList.add('visible'); });
    }, { threshold: 0.12 });
    document.querySelectorAll('.slim-card, .slim-card-h, .slim-support-card, .slim-media-panel').forEach(el => observer.observe(el));
    setTimeout(() => {
      document.querySelectorAll('.slim-card, .slim-card-h, .slim-support-card, .slim-media-panel').forEach((el,i) => { if(i<4) el.classList.add('visible'); });
    }, 150);
  }
})();

(function() {
      // Local scope variables
      const module = document.getElementById('Mepilo-module');
      if (!module) return;

      // ============ PARTICLES ============
      const particlesContainer = document.getElementById('svParticles');
      if (particlesContainer && window.matchMedia('(prefers-reduced-motion: no-preference)').matches) {
        for (let i = 0; i < 18; i++) {
          const p = document.createElement('div');
          p.className = 'sv-particle';
          const size = Math.random() * 5 + 3;
          p.style.width = `${size}px`;
          p.style.height = `${size}px`;
          p.style.left = `${Math.random() * 90}%`;
          p.style.top = `${Math.random() * 70 + 15}%`;
          p.style.animationDuration = `${Math.random() * 8 + 7}s`;
          p.style.animationDelay = `${Math.random() * 9}s`;
          particlesContainer.appendChild(p);
        }
      }

      // ============ DOM ELEMENTS ============
      const imgWrap = document.getElementById('svImageWrap');
      const cards = module.querySelectorAll('.sv-card');
      const dots = module.querySelectorAll('.sv-connection-dot');

      // Helper to clear image states
      const clearImageClasses = () => {
        if (!imgWrap) return;
        imgWrap.classList.remove('image-resonate', 'image-resonate-top', 'image-resonate-bottom', 'image-lean-left', 'image-lean-right', 'image-all-glow');
      };

      // Helper to reset dots
      const resetDots = () => {
        dots.forEach(d => d.classList.remove('pulse-active'));
      };

      // Helper to activate specific dot
      const activateDot = (index) => {
        resetDots();
        const dot = module.querySelector(`.sv-connection-dot[data-dot="${index}"]`);
        if (dot) dot.classList.add('pulse-active');
      };

      // ============ MOBILE DRAG INERTIA & IMAGE RESONANCE ============
      const isMobile = () => window.innerWidth < 768;

      cards.forEach(card => {
        let isDragging = false, startX = 0, startY = 0;
        let currentX = 0, currentY = 0, velX = 0, velY = 0;
        let lastX = 0, lastY = 0, animationId = null;
        let hasMoved = false;
        const MOVE_THRESHOLD = 4;

        const applyTransform = (x, y) => {
          card.style.transform = `translate(${x}px, ${y}px)`;
          card.style.transition = 'none';
        };

        const resetCard = (animate = true) => {
          if (animate) {
            card.style.transition = 'transform 0.5s cubic-bezier(0.25,0.8,0.25,1.2)';
            card.style.transform = '';
          } else {
            card.style.transition = 'none';
            card.style.transform = '';
          }
        };

        const setImageResonance = (cardId) => {
          if (!imgWrap || !isMobile()) return;
          clearImageClasses();
          const id = parseInt(cardId);
          if (id === 0 || id === 1) imgWrap.classList.add('image-resonate-top');
          else if (id === 2 || id === 3) imgWrap.classList.add('image-resonate-bottom');
        };

        const onPointerDown = (e) => {
          if (!isMobile() && e.pointerType === 'mouse') return;
          isDragging = true;
          hasMoved = false;
          card.setPointerCapture(e.pointerId);
          startX = e.clientX; startY = e.clientY;
          lastX = startX; lastY = startY;
          currentX = 0; currentY = 0; velX = 0; velY = 0;
          if (animationId) { cancelAnimationFrame(animationId); animationId = null; }
          card.style.transition = 'none';
          card.style.cursor = 'grabbing';
          
          const cardId = card.getAttribute('data-card-id');
          if (cardId !== null) setImageResonance(cardId);
        };

        const onPointerMove = (e) => {
          if (!isDragging) return;
          currentX = (e.clientX - startX) * 0.85;
          currentY = (e.clientY - startY) * 0.85;
          applyTransform(currentX, currentY);
          velX = e.clientX - lastX;
          velY = e.clientY - lastY;
          lastX = e.clientX; lastY = e.clientY;
          if (Math.abs(currentX) > MOVE_THRESHOLD || Math.abs(currentY) > MOVE_THRESHOLD) {
            hasMoved = true;
          }
        };

        const onPointerUp = (e) => {
          if (!isDragging) return;
          isDragging = false;
          card.releasePointerCapture(e.pointerId);
          card.style.cursor = 'grab';
          clearImageClasses();
          
          let ix = currentX, iy = currentY;
          let vx = velX * 0.75, vy = velY * 0.75;
          const friction = 0.9, minV = 0.4;

          const step = () => {
            if (Math.abs(vx) < minV && Math.abs(vy) < minV && Math.abs(ix) < 0.4 && Math.abs(iy) < 0.4) {
              resetCard(true);
              animationId = null;
              return;
            }
            ix += vx; iy += vy;
            vx *= friction; vy *= friction;
            applyTransform(ix, iy);
            animationId = requestAnimationFrame(step);
          };
          animationId = requestAnimationFrame(step);
        };

        card.addEventListener('pointerdown', onPointerDown);
        card.addEventListener('pointermove', onPointerMove);
        card.addEventListener('pointerup', onPointerUp);
        card.addEventListener('pointercancel', onPointerUp);
        card.addEventListener('dragstart', e => e.preventDefault());

        // Touch hover fallback
        card.addEventListener('pointerenter', (e) => {
          if (!isMobile() && e.pointerType === 'mouse') return;
          if (isDragging && hasMoved) return;
          const cardId = card.getAttribute('data-card-id');
          if (cardId !== null && !isDragging) setImageResonance(cardId);
        });
        card.addEventListener('pointerleave', () => {
          if (!isMobile()) return;
          if (!isDragging) clearImageClasses();
        });
      });

      // Mobile image hover
      if (imgWrap) {
        imgWrap.addEventListener('pointerenter', () => {
          if (!isMobile()) return;
          clearImageClasses();
          imgWrap.classList.add('image-resonate');
        });
        imgWrap.addEventListener('pointerleave', () => {
          if (!isMobile()) return;
          imgWrap.classList.remove('image-resonate', 'image-resonate-top', 'image-resonate-bottom');
        });
      }

      // ============ DESKTOP INTERACTIONS (Image Tilt & Dots) ============
      if (imgWrap) {
        const desktopCards = module.querySelectorAll('.sv-card');
        
        desktopCards.forEach(card => {
          card.addEventListener('mouseenter', () => {
            if (isMobile()) return;
            const idx = card.getAttribute('data-card-id');
            if (idx !== null) {
              const i = parseInt(idx);
              activateDot(i);
              clearImageClasses();
              if (i === 0 || i === 1) imgWrap.classList.add('image-lean-left');
              else if (i === 2 || i === 3) imgWrap.classList.add('image-lean-right');
            }
          });
          card.addEventListener('mouseleave', () => {
            if (isMobile()) return;
            resetDots();
            clearImageClasses();
          });
        });

        imgWrap.addEventListener('mouseenter', () => {
          if (isMobile()) return;
          dots.forEach(d => d.classList.add('pulse-active'));
          clearImageClasses();
          imgWrap.classList.add('image-all-glow');
        });
        imgWrap.addEventListener('mouseleave', () => {
          if (isMobile()) return;
          resetDots();
          clearImageClasses();
        });
      }

      // ============ INTERSECTION OBSERVER ============
      const animatedEls = module.querySelectorAll('.sv-header__badge,.sv-header__title,.sv-header__sub,.sv-trust-strip');
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) entry.target.style.animationPlayState = 'running';
        });
      }, { threshold: 0.2 });
      animatedEls.forEach(el => observer.observe(el));

      console.log('✅ Mepilo™ ready — Responsive Shopify Liquid Module');
    })();

(function() {
        var moduleData = {
            badge: "Science Driven",
            title: "Quiet The Noise. Restore Steady Control.",
            subtitle: "Our transdermal approach works with your body's own bio-electric field, harmonizing signals that keep you steady.",
            imageUrl: "https://placehold.co/600x600/0e0e18/fd8e03?text=Mepilo+Tech",
            desktopImageUrl: "https://placehold.co/600x600/0e0e18/fd8e03?text=Mepilo+Pro",
            imageBadge: "Tech View",
            statNumber: "97%",
            statLabel: "reported noticeable improvement within 2 weeks.",
            cards: [
                { num: "1", title: "Conductive Balance", desc: "Bio-electric field support for clearer nervous system communication.", tag: "Core Layer" },
                { num: "2", title: "Flexible Comfort", desc: "Thin, lightweight — moves with every bend.", tag: "Comfort" },
                { num: "3", title: "12-Hour Support", desc: "Up to 12 hours of consistent, steady wear.", tag: "Extended" },
                { num: "4", title: "Protective Shield", desc: "Guards against environmental factors.", tag: "Outer" },
                { num: "5", title: "Gentle Adhesion", desc: "Hypoallergenic, secure, zero residue.", tag: "Medical" },
                { num: "6", title: "Drug-Free", desc: "Zero active pharmaceutical ingredients.", tag: "Natural" }
            ]
        };

        function createCardHTML(card, isDesktop, alignRight) {
            var iconRow = '';
            if (isDesktop && alignRight) {
                iconRow = '<div class="sv-card__icon-row" style="justify-content:flex-end;">'
                    + '<h3>' + card.title + '</h3>'
                    + '<div class="sv-card__diamond"><span>' + card.num + '</span></div>'
                    + '</div>';
            } else {
                iconRow = '<div class="sv-card__icon-row">'
                    + '<div class="sv-card__diamond"><span>' + card.num + '</span></div>'
                    + '<h3>' + card.title + '</h3>'
                    + '</div>';
            }
            var descAlign = (isDesktop && alignRight) ? 'text-align:right;' : '';
            var tagAlign = (isDesktop && alignRight) ? 'align-self:flex-end;' : '';
            return '<div class="sv-card" data-card-index="' + (parseInt(card.num) - 1) + '">'
                + iconRow
                + '<p class="sv-card__desc" style="' + descAlign + '">' + card.desc + '</p>'
                + '<span class="sv-card__tag" style="' + tagAlign + '">' + card.tag + '</span>'
                + '</div>';
        }

        function render() {
            var container = document.getElementById('svContent');
            if (!container) return;
            var d = moduleData;
            var c = d.cards;
            var mobileCardsHTML = '';
            for (var i = 0; i < c.length; i++) {
                mobileCardsHTML += createCardHTML(c[i], false, false);
            }
            var desktopLeft = '';
            for (var i = 0; i < 3; i++) {
                desktopLeft += createCardHTML(c[i], true, true);
            }
            var desktopRight = '';
            for (var i = 3; i < 6; i++) {
                desktopRight += createCardHTML(c[i], true, false);
            }

            container.innerHTML =
                '<div class="sv-header">'
                + '<div class="sv-header__badge"><span class="sv-header__badge-dot"></span> ' + d.badge + '</div>'
                + '<h2 class="sv-header__title">' + d.title + '</h2>'
                + '<p class="sv-header__sub">' + d.subtitle + '</p>'
                + '</div>'
                + '<div class="sv-mobile-layout">'
                + '<div class="sv-mobile-image-wrap">'
                + '<div class="sv-image-glow-ring"></div>'
                + '<img src="https://cdn.shopify.com/s/files/1/0680/4727/4135/files/DM_20260706134156_001_81ebe2f8-68ac-414d-9b5c-983ed8b10289.jpg?v=1783341720" alt="Mepilo™ technology" loading="lazy">'
                + '<div class="sv-image-badge">' + d.imageBadge + '</div>'
                + '</div>'
                + '<div class="sv-mobile-cards-grid">' + mobileCardsHTML + '</div>'
                + '</div>'
                + '<div class="sv-desktop-layout">'
                + '<div class="sv-desktop-col sv-desktop-col--left">' + desktopLeft + '</div>'
                + '<div class="sv-desktop-image-wrap" id="svDesktopImage">'
                + '<div class="sv-image-glow-ring"></div>'
                + '<img src="https://cdn.shopify.com/s/files/1/0680/4727/4135/files/DM_20260706134156_001_81ebe2f8-68ac-414d-9b5c-983ed8b10289.jpg?v=1783341720" alt="Mepilo™ technology" loading="lazy">'
                + '<div class="sv-conn-dot sv-conn-dot--l1" data-dot="0"></div>'
                + '<div class="sv-conn-dot sv-conn-dot--l2" data-dot="1"></div>'
                + '<div class="sv-conn-dot sv-conn-dot--l3" data-dot="2"></div>'
                + '<div class="sv-conn-dot sv-conn-dot--r1" data-dot="3"></div>'
                + '<div class="sv-conn-dot sv-conn-dot--r2" data-dot="4"></div>'
                + '<div class="sv-conn-dot sv-conn-dot--r3" data-dot="5"></div>'
                + '<div class="sv-image-badge">' + d.imageBadge + '</div>'
                + '</div>'
                + '<div class="sv-desktop-col sv-desktop-col--right">' + desktopRight + '</div>'
                + '</div>'
                + '<div class="sv-stat">'
                + '<div class="sv-stat__number">' + d.statNumber + '</div>'
                + '<div class="sv-stat__label">' + d.statLabel + '</div>'
                + '</div>';
        }

        render();

        function initDesktopInteractions() {
            var desktopImage = document.getElementById('svDesktopImage');
            if (!desktopImage) return;
            var dots = desktopImage.querySelectorAll('.sv-conn-dot');
            var dCards = document.querySelectorAll('#Mepilo-science .sv-desktop-col .sv-card');

            function resetDots() {
                for (var i = 0; i < dots.length; i++) {
                    dots[i].classList.remove('pulse-active');
                }
            }
            function activateDot(idx) {
                resetDots();
                var dot = desktopImage.querySelector('.sv-conn-dot[data-dot="' + idx + '"]');
                if (dot) dot.classList.add('pulse-active');
            }
            for (var j = 0; j < dCards.length; j++) {
                dCards[j].addEventListener('mouseenter', function() {
                    var idx = parseInt(this.getAttribute('data-card-index'));
                    if (!isNaN(idx)) {
                        activateDot(idx);
                        if (this.closest('.sv-desktop-col--left')) {
                            desktopImage.classList.add('glow-left');
                            desktopImage.classList.remove('glow-right');
                        } else {
                            desktopImage.classList.add('glow-right');
                            desktopImage.classList.remove('glow-left');
                        }
                    }
                });
                dCards[j].addEventListener('mouseleave', function() {
                    resetDots();
                    desktopImage.classList.remove('glow-left', 'glow-right');
                });
            }
            desktopImage.addEventListener('mouseenter', function() {
                for (var k = 0; k < dots.length; k++) {
                    dots[k].classList.add('pulse-active');
                }
            });
            desktopImage.addEventListener('mouseleave', function() {
                for (var k = 0; k < dots.length; k++) {
                    dots[k].classList.remove('pulse-active');
                }
            });
        }

        function initObserver() {
            var section = document.getElementById('Mepilo-science');
            if (!section) return;
            var animEls = section.querySelectorAll(
                '.sv-header__badge, .sv-header__title, .sv-header__sub, .sv-stat, .sv-desktop-layout'
            );
            function tryRunAnimation(el) {
                var rect = el.getBoundingClientRect();
                if (rect.top < window.innerHeight && rect.bottom > 0) {
                    el.style.animationPlayState = 'running';
                    el.style.opacity = '1';
                    return true;
                }
                return false;
            }
            for (var i = 0; i < animEls.length; i++) {
                tryRunAnimation(animEls[i]);
            }
            if ('IntersectionObserver' in window) {
                var observer = new IntersectionObserver(function(entries) {
                    for (var e = 0; e < entries.length; e++) {
                        if (entries[e].isIntersecting) {
                            entries[e].target.style.animationPlayState = 'running';
                            entries[e].target.style.opacity = '1';
                        }
                    }
                }, { threshold: 0.2 });
                for (var j = 0; j < animEls.length; j++) {
                    observer.observe(animEls[j]);
                }
            }
        }

        initDesktopInteractions();
        initObserver();
    })();

(function() {
  window.addEventListener('DOMContentLoaded', function() {
    const carousel = document.getElementById('slimReviewsCarousel');
    const dotsContainer = document.getElementById('slimReviewsDots');
    if (!carousel) return;

    // ===== Clone cards for seamless infinite loop =====
    const originalCards = Array.from(carousel.querySelectorAll('.slim-review-card'));
    const totalOriginal = originalCards.length;
    if (totalOriginal === 0) return;

    // Clone each original card and append to carousel
    originalCards.forEach(function(card) {
      const clone = card.cloneNode(true);
      // Reset like state on clones (they'll be managed independently via event delegation)
      const cloneBtn = clone.querySelector('.slim-review-like-btn');
      if (cloneBtn) {
        cloneBtn.classList.remove('liked');
        cloneBtn.dataset.liked = 'false';
        const countSpan = cloneBtn.querySelector('.slim-review-like-count');
        if (countSpan && cloneBtn.dataset.originalCount) {
          countSpan.textContent = cloneBtn.dataset.originalCount;
        }
      }
      carousel.appendChild(clone);
    });

    const allDots = dotsContainer ? dotsContainer.querySelectorAll('.slim-dot') : [];
    // Reference card for width calculations (use first original card)
    const refCard = originalCards[0];

    // ===== Helper: get card step (card width + gap) =====
    function getCardStep() {
      if (originalCards.length < 2) {
        const gap = parseFloat(getComputedStyle(carousel).gap) || 20;
        return refCard.offsetWidth + gap;
      }
      return originalCards[1].offsetLeft - originalCards[0].offsetLeft;
    }

    // ===== Helper: get original set width (all original cards + gaps) =====
    function getOriginalSetWidth() {
      // The first cloned card's offsetLeft equals the total width of the original set
      const allCards = carousel.querySelectorAll('.slim-review-card');
      if (allCards.length > totalOriginal) {
        return allCards[totalOriginal].offsetLeft;
      }
      // Fallback
      return getCardStep() * totalOriginal;
    }

    // ===== Helper: normalize scrollLeft to stay within original set bounds =====
    function normalizeScrollPosition() {
      const origWidth = getOriginalSetWidth();
      if (origWidth <= 0) return;
      let sl = carousel.scrollLeft;
      if (sl >= origWidth) {
        // Wrap back into original range using modulo
        sl = sl % origWidth;
        carousel.scrollLeft = sl;
      }
      // Also handle rare case of negative scroll
      if (sl < 0) {
        sl = ((sl % origWidth) + origWidth) % origWidth;
        carousel.scrollLeft = sl;
      }
    }

    // ===== Update active dot based on current scroll position =====
    function updateActiveDot() {
      if (!allDots.length) return;
      const cardStep = getCardStep();
      if (cardStep <= 0) return;
      const origWidth = getOriginalSetWidth();
      // Use modulo to map scroll position back to 0..(totalOriginal-1)
      let normalizedLeft = carousel.scrollLeft % origWidth;
      if (normalizedLeft < 0) normalizedLeft += origWidth;
      const idx = Math.round(normalizedLeft / cardStep) % totalOriginal;
      allDots.forEach(function(dot, i) {
        dot.classList.toggle('active', i === idx);
      });
    }

    // ===== Dot click navigation =====
    allDots.forEach(function(dot) {
      dot.addEventListener('click', function() {
        const targetIndex = parseInt(this.dataset.dot, 10);
        if (isNaN(targetIndex)) return;
        const cardStep = getCardStep();
        const scrollTo = targetIndex * cardStep;
        // Ensure we stay within original set
        const origWidth = getOriginalSetWidth();
        const targetLeft = Math.min(scrollTo, origWidth - 1);
        carousel.scrollTo({ left: Math.max(0, targetLeft), behavior: 'smooth' });
        setTimeout(updateActiveDot, 400);
      });
    });

    // ===== Auto‑scroll: 1s interval, seamless infinite loop =====
    let autoScrollInterval;
    let isPaused = false;
    let isProgrammaticScroll = false;

    function scrollToNext() {
      if (!carousel || isPaused) return;
      // Normalize position first (in case user dragged into clone zone)
      normalizeScrollPosition();

      const cardStep = getCardStep();
      const origWidth = getOriginalSetWidth();
      if (cardStep <= 0 || origWidth <= 0) return;

      let targetLeft = carousel.scrollLeft + cardStep;

      // If target exceeds or equals original set width, wrap around
      if (targetLeft >= origWidth - 2) {
        targetLeft = targetLeft - origWidth;
      }

      isProgrammaticScroll = true;
      carousel.scrollTo({ left: Math.max(0, targetLeft), behavior: 'smooth' });

      // Clear programmatic flag after smooth scroll completes
      setTimeout(function() {
        isProgrammaticScroll = false;
        updateActiveDot();
      }, 400);
    }

    function startAutoScroll() {
      stopAutoScroll();
      isPaused = false;
      autoScrollInterval = setInterval(scrollToNext, 1000);
    }

    function stopAutoScroll() {
      if (autoScrollInterval) clearInterval(autoScrollInterval);
      autoScrollInterval = null;
    }

    function pauseAutoScroll() {
      isPaused = true;
      stopAutoScroll();
    }

    function resumeAutoScroll(delayMs) {
      stopAutoScroll();
      setTimeout(function() {
        isPaused = false;
        startAutoScroll();
      }, delayMs || 300);
    }

    startAutoScroll();

    // Hover pause
    carousel.addEventListener('mouseenter', pauseAutoScroll);
    carousel.addEventListener('mouseleave', function() {
      resumeAutoScroll(400);
    });

    // Touch pause
    carousel.addEventListener('touchstart', pauseAutoScroll, { passive: true });
    carousel.addEventListener('touchend', function() {
      resumeAutoScroll(2500);
    });

    // ===== Scroll event: update dots + normalize on user scroll =====
    let scrollDebounceTimer;
    carousel.addEventListener('scroll', function() {
      updateActiveDot();

      // Debounce normalization for user-initiated scrolls (not programmatic)
      if (!isProgrammaticScroll) {
        clearTimeout(scrollDebounceTimer);
        scrollDebounceTimer = setTimeout(function() {
          normalizeScrollPosition();
          updateActiveDot();
        }, 180);
      }
    }, { passive: true });

    // Initial dot state
    updateActiveDot();

    // ===== Toggle Like button – event delegation on carousel =====
    carousel.addEventListener('click', function(e) {
      const btn = e.target.closest('.slim-review-like-btn');
      if (!btn) return;

      e.stopPropagation();
      e.preventDefault();

      const countSpan = btn.querySelector('.slim-review-like-count');
      const icon = btn.querySelector('.slim-like-icon');
      let currentCount = parseInt(countSpan.textContent, 10);

      if (btn.dataset.liked === 'false') {
        // --- LIKE ---
        currentCount++;
        countSpan.textContent = currentCount;
        btn.classList.add('liked');
        btn.dataset.liked = 'true';

        if (icon) {
          icon.classList.remove('like-animate-out');
          icon.classList.add('like-animate-in');
          setTimeout(function() { icon.classList.remove('like-animate-in'); }, 380);
        }
        countSpan.classList.remove('count-animate-out');
        countSpan.classList.add('count-animate-in');
        setTimeout(function() { countSpan.classList.remove('count-animate-in'); }, 350);
      } else {
        // --- UNLIKE ---
        currentCount--;
        countSpan.textContent = currentCount;
        btn.classList.remove('liked');
        btn.dataset.liked = 'false';

        if (icon) {
          icon.classList.remove('like-animate-in');
          icon.classList.add('like-animate-out');
          setTimeout(function() { icon.classList.remove('like-animate-out'); }, 380);
        }
        countSpan.classList.remove('count-animate-in');
        countSpan.classList.add('count-animate-out');
        setTimeout(function() { countSpan.classList.remove('count-animate-out'); }, 350);
      }
    });

    // Prevent double-tap zoom on like buttons via touch handling on carousel
    carousel.addEventListener('touchend', function(e) {
      const btn = e.target.closest('.slim-review-like-btn');
      if (btn) {
        e.preventDefault();
        btn.click();
      }
    });
  });
})();

(function() {
                        const gallery = document.getElementById('svUgcStack');
                        if (!gallery) return;

                        const label = document.getElementById('svUgcLabel');
                        const title = document.getElementById('svUgcTitle');
                        const allCards = gallery.querySelectorAll('.sv-ugc-stack__card, .sv-ugc-stack__hero');

                        // 入场动画
                        const observer = new IntersectionObserver((entries) => {
                            entries.forEach(entry => {
                                if (entry.isIntersecting) {
                                    if (label) label.classList.add('visible');
                                    if (title) title.classList.add('visible');
                                    allCards.forEach(card => {
                                        const delay = parseInt(card.getAttribute('data-delay')) || 0;
                                        setTimeout(() => card.classList.add('visible'), delay + 160);
                                    });
                                    observer.unobserve(entry.target);
                                }
                            });
                        }, { threshold: 0.12 });
                        observer.observe(gallery);

                        // 点击置顶逻辑
                        let topZ = 5000;
                        allCards.forEach(card => {
                            card.addEventListener('click', function(e) {
                                e.stopPropagation();
                                // 移除其他卡片的高亮状态
                                allCards.forEach(c => {
                                    c.classList.remove('is-top');
                                    c.style.zIndex = '';
                                    c.style.transform = '';
                                    c.style.boxShadow = '';
                                });
                                // 当前卡片置顶
                                this.classList.add('is-top');
                                topZ += 1;
                                this.style.zIndex = topZ;
                                this.style.transform = 'scale(1.08)';
                                this.style.boxShadow = '0 22px 52px rgba(0,0,0,0.18), 0 0 0 3px rgba(253,142,3,0.28)';
                                this.style.transition = 'transform 0.35s cubic-bezier(0.34,1.56,0.64,1), box-shadow 0.35s ease';
                            });

                            // 悬停效果 (仅对非置顶卡片生效)
                            card.addEventListener('mouseenter', function() {
                                if (!this.classList.contains('is-top')) {
                                    this.style.zIndex = 60;
                                    this.style.transform = 'scale(1.05)';
                                    this.style.boxShadow = '0 12px 34px rgba(0,0,0,0.11), 0 0 0 2px rgba(253,142,3,0.14)';
                                    this.style.transition = 'transform 0.35s cubic-bezier(0.34,1.56,0.64,1), box-shadow 0.35s ease';
                                    // 显示光点
                                    const glow = this.querySelector('.sv-ugc-stack__glow');
                                    if (glow) {
                                        glow.style.opacity = '1';
                                        glow.style.transform = 'scale(2.2)';
                                        glow.style.boxShadow = '0 0 16px 6px rgba(253,142,3,0.5)';
                                    }
                                }
                            });
                            card.addEventListener('mouseleave', function() {
                                if (!this.classList.contains('is-top')) {
                                    this.style.zIndex = '';
                                    this.style.transform = '';
                                    this.style.boxShadow = '';
                                    this.style.transition = '';
                                    const glow = this.querySelector('.sv-ugc-stack__glow');
                                    if (glow) {
                                        glow.style.opacity = '';
                                        glow.style.transform = '';
                                        glow.style.boxShadow = '';
                                    }
                                }
                            });
                        });

                        console.log('✅ Mepilo™ UGC — click to top, scale & glow');
                    })();

(function() {
                        const gallery = document.getElementById('svUgcStack');
                        if (!gallery) return;

                        const label = document.getElementById('svUgcLabel');
                        const title = document.getElementById('svUgcTitle');
                        const allCards = gallery.querySelectorAll('.sv-ugc-stack__card, .sv-ugc-stack__hero');

                        // 入场动画
                        const observer = new IntersectionObserver((entries) => {
                            entries.forEach(entry => {
                                if (entry.isIntersecting) {
                                    if (label) label.classList.add('visible');
                                    if (title) title.classList.add('visible');
                                    allCards.forEach(card => {
                                        const delay = parseInt(card.getAttribute('data-delay')) || 0;
                                        setTimeout(() => card.classList.add('visible'), delay + 160);
                                    });
                                    observer.unobserve(entry.target);
                                }
                            });
                        }, { threshold: 0.12 });
                        observer.observe(gallery);

                        // 点击置顶逻辑
                        let topZ = 5000;
                        allCards.forEach(card => {
                            card.addEventListener('click', function(e) {
                                e.stopPropagation();
                                // 移除其他卡片的高亮状态
                                allCards.forEach(c => {
                                    c.classList.remove('is-top');
                                    c.style.zIndex = '';
                                    c.style.transform = '';
                                    c.style.boxShadow = '';
                                });
                                // 当前卡片置顶
                                this.classList.add('is-top');
                                topZ += 1;
                                this.style.zIndex = topZ;
                                this.style.transform = 'scale(1.08)';
                                this.style.boxShadow = '0 22px 52px rgba(0,0,0,0.18), 0 0 0 3px rgba(253,142,3,0.28)';
                                this.style.transition = 'transform 0.35s cubic-bezier(0.34,1.56,0.64,1), box-shadow 0.35s ease';
                            });

                            // 悬停效果 (仅对非置顶卡片生效)
                            card.addEventListener('mouseenter', function() {
                                if (!this.classList.contains('is-top')) {
                                    this.style.zIndex = 60;
                                    this.style.transform = 'scale(1.05)';
                                    this.style.boxShadow = '0 12px 34px rgba(0,0,0,0.11), 0 0 0 2px rgba(253,142,3,0.14)';
                                    this.style.transition = 'transform 0.35s cubic-bezier(0.34,1.56,0.64,1), box-shadow 0.35s ease';
                                    // 显示光点
                                    const glow = this.querySelector('.sv-ugc-stack__glow');
                                    if (glow) {
                                        glow.style.opacity = '1';
                                        glow.style.transform = 'scale(2.2)';
                                        glow.style.boxShadow = '0 0 16px 6px rgba(253,142,3,0.5)';
                                    }
                                }
                            });
                            card.addEventListener('mouseleave', function() {
                                if (!this.classList.contains('is-top')) {
                                    this.style.zIndex = '';
                                    this.style.transform = '';
                                    this.style.boxShadow = '';
                                    this.style.transition = '';
                                    const glow = this.querySelector('.sv-ugc-stack__glow');
                                    if (glow) {
                                        glow.style.opacity = '';
                                        glow.style.transform = '';
                                        glow.style.boxShadow = '';
                                    }
                                }
                            });
                        });

                        console.log('✅ Mepilo™ UGC — click to top, scale & glow');
                    })();

(function() {
  window.addEventListener('DOMContentLoaded', function() {
    const faqList = document.querySelector('.sv-faq-list');
    if (!faqList) return;

    const items = faqList.querySelectorAll('.sv-faq-item');
    const questions = faqList.querySelectorAll('.sv-faq-question');

    questions.forEach((question, index) => {
      question.addEventListener('click', () => {
        const item = items[index];
        const isOpen = item.classList.contains('is-open');

        // 关闭所有其他项
        items.forEach((otherItem, otherIndex) => {
          if (otherIndex !== index && otherItem.classList.contains('is-open')) {
            otherItem.classList.remove('is-open');
            const otherAnswer = otherItem.querySelector('.sv-faq-answer');
            if (otherAnswer) {
              otherAnswer.style.maxHeight = '0px';
            }
            const otherBtn = otherItem.querySelector('.sv-faq-question');
            if (otherBtn) otherBtn.setAttribute('aria-expanded', 'false');
          }
        });

        // 切换当前项
        if (isOpen) {
          item.classList.remove('is-open');
          question.setAttribute('aria-expanded', 'false');
          const answer = item.querySelector('.sv-faq-answer');
          if (answer) {
            answer.style.maxHeight = '0px';
          }
        } else {
          item.classList.add('is-open');
          question.setAttribute('aria-expanded', 'true');
          const answer = item.querySelector('.sv-faq-answer');
          if (answer) {
            answer.style.maxHeight = answer.scrollHeight + 'px';
          }
        }
      });

      // 键盘支持
      question.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          question.click();
        }
      });
    });
  });
})();

(function() {
            const module = document.getElementById('Mepilo-final');
            if (!module) return;

            // ============ FLOATING PARTICLES ============
            const particlesLayer = document.getElementById('svParticlesLayer');
            const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

            if (particlesLayer && !prefersReducedMotion) {
                const particleCount = window.innerWidth < 768 ? 8 : 14;
                for (let i = 0; i < particleCount; i++) {
                    const particle = document.createElement('div');
                    particle.className = 'sv-particle';
                    const size = Math.random() * 4 + 3;
                    particle.style.width = size + 'px';
                    particle.style.height = size + 'px';
                    particle.style.left = (Math.random() * 85 + 5) + '%';
                    particle.style.top = (Math.random() * 75 + 15) + '%';
                    particle.style.animationDuration = (Math.random() * 9 + 8) + 's';
                    particle.style.animationDelay = (Math.random() * 10) + 's';
                    particle.style.opacity = (Math.random() * 0.35 + 0.1);
                    particlesLayer.appendChild(particle);
                }
            }

            // ============ INTERSECTION OBSERVER – Entrance animations ============
            const titleEl = document.getElementById('svTitle');
            const descEl = document.getElementById('svDesc');
            const btnWrapEl = document.getElementById('svBtnWrap');
            const paymentRowEl = document.getElementById('svPaymentRow');
            const guaranteeEl = document.getElementById('svGuarantee');

            const animElements = [titleEl, descEl, btnWrapEl, paymentRowEl, guaranteeEl].filter(Boolean);

            const observer = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        animElements.forEach(el => el.classList.add('visible'));
                        observer.unobserve(entry.target);
                    }
                });
            }, {
                threshold: 0.2,
                rootMargin: '0px 0px -20px 0px'
            });

            observer.observe(module);

            console.log('✅ Mepilo™ CTA ready — Premium layered module');
        })();

(function initAncientkaSideDeal() {
        var root = document.getElementById('svSideDeal');
        var trigger = document.getElementById('svSideDealTrigger');
        var closeBtn = document.getElementById('svSideDealClose');
        var panel = document.getElementById('svSideDealPanel');
        var productUrl = 'https://ancientka.com/products/balance-support-patch77';

        if (!root || !trigger || !closeBtn || !panel) return;
        if (root.getAttribute('data-sv-initialized') === 'true') return;
        root.setAttribute('data-sv-initialized', 'true');

        function openPanel() {
            root.classList.add('is-open');
            trigger.setAttribute('aria-expanded', 'true');
            panel.setAttribute('aria-hidden', 'false');
        }

        function closePanel() {
            root.classList.remove('is-open');
            trigger.setAttribute('aria-expanded', 'false');
            panel.setAttribute('aria-hidden', 'true');
        }

        trigger.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            if (root.classList.contains('is-open')) closePanel();
            else openPanel();
        });

        closeBtn.addEventListener('click', function(e) {
            e.stopPropagation();
            closePanel();
        });

        document.addEventListener('click', function(e) {
            if (!root.contains(e.target)) closePanel();
        });

        document.addEventListener('keydown', function(e) {
            if (e.key === 'Escape' && root.classList.contains('is-open')) {
                closePanel();
                trigger.focus();
            }
        });

        console.log('✅ Mepilo™ Side Deal — warm amber-orange CTA ready');
    })();

(() => {
        const COUNTDOWN_DURATION = 5 * 60 * 60 * 1000; // 5小时
        const STORAGE_KEY = 'Mepilo_warm_countdown_end';
        let endTime = localStorage.getItem(STORAGE_KEY);
        const now = Date.now();

        if (!endTime || now > parseInt(endTime) || (parseInt(endTime) - now > COUNTDOWN_DURATION + 10000)) {
            endTime = now + COUNTDOWN_DURATION;
            localStorage.setItem(STORAGE_KEY, endTime);
        } else {
            endTime = parseInt(endTime);
        }

        const digitIds = ['svDigitH1', 'svDigitH2', 'svDigitM1', 'svDigitM2', 'svDigitS1', 'svDigitS2'];
        const prevDigits = {};
        digitIds.forEach(id => { prevDigits[id] = null; });

        const padTwo = (n) => String(n).padStart(2, '0');
        const getRemainingTimeStr = () => {
            const remaining = endTime - Date.now();
            if (remaining <= 0) return '00:00:00';
            const totalSec = Math.floor(remaining / 1000);
            const h = Math.floor(totalSec / 3600);
            const m = Math.floor((totalSec % 3600) / 60);
            const s = totalSec % 60;
            return `${padTwo(h)}:${padTwo(m)}:${padTwo(s)}`;
        };

        const triggerPulse = (id) => {
            const el = document.getElementById(id);
            if (!el) return;
            el.classList.remove('pulse');
            void el.offsetWidth;
            el.classList.add('pulse');
        };

        const updateDisplay = (timeStr) => {
            const parts = timeStr.split(':');
            if (parts.length !== 3) return;
            const digits = [parts[0][0], parts[0][1], parts[1][0], parts[1][1], parts[2][0], parts[2][1]];
            digitIds.forEach((id, i) => {
                const newDigit = digits[i];
                const el = document.getElementById(id);
                if (!el) return;
                if (prevDigits[id] !== null && prevDigits[id] !== newDigit) {
                    el.textContent = newDigit;
                    triggerPulse(id);
                } else if (prevDigits[id] === null) {
                    el.textContent = newDigit;
                }
                prevDigits[id] = newDigit;
            });
        };

        const initStr = getRemainingTimeStr();
        updateDisplay(initStr);
        setInterval(() => updateDisplay(getRemainingTimeStr()), 1000);

        console.log('✅ Mepilo™ Luxury Bottom Bar — warm amber-gold theme ready');
    })();

(function(){
  var CTA_URL = 'https://ancientka.com/products/balance-support-patch77';
  document.querySelectorAll('a[href]').forEach(function(link){
    var href = link.getAttribute('href') || '';
    var signature = ((link.className || '') + ' ' + (link.textContent || '')).toLowerCase();
    if (/mepilo\.com\/products\/balance-support-patch77/i.test(href) || /(^|\s)(cta|sv-btn|slim-support-cta)(\s|$)/i.test(signature)) {
      link.setAttribute('href', CTA_URL);
    }
  });
})();
